import { enableProdMode, importProvidersFrom } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { environment } from "./environments/environment";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { provideRouter } from "@angular/router";
import {
  withInterceptorsFromDi,
  provideHttpClient,
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { APP_ROUTES } from "./app/app.routes";
import { provideAnimations } from "@angular/platform-browser/animations";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpRequestInterceptor } from "./app/shared/services/http.service";
import { provideEnvironmentNgxMask } from "ngx-mask";
import { MatSnackBarModule } from "@angular/material/snack-bar";

export function getBaseUrl() {
  return document.getElementsByTagName("base")[0].href;
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const providers = [{ provide: "BASE_URL", useFactory: getBaseUrl, deps: [] }];

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
    provideEnvironmentNgxMask(),
    importProvidersFrom(
      MatSnackBarModule,
      HttpClientModule,
      TranslateModule.forRoot({
        defaultLanguage: "en",
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      }),
    ),
    provideRouter(APP_ROUTES),
    provideAnimations(),
  ],
}).catch((err) => console.log(err));
